import Toman from '@/app/_components/ui/icons/Toman.svg';
import React from 'react';

export default function PriceUnit({ price, color }) {
  return (
    <>
      <span className={`pl-1`}>{price?.toLocaleString('fa-IR')}</span>
      <Toman fill={color} />
    </>
  );
}
